import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../contexts/AdminContext";
import "../styles/Logout.css";

const Logout = () => {
  const { logout } = useAdmin();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="logout-backdrop" onClick={handleCancel}>
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Are you sure you want to logout?</h2>
        <div className="logout-buttons">
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
